import React from "react";
import { Popover, Button } from "antd";

function SignOutDropDown({ menu, icon }) {
  return (
    <Popover
      placement="bottomRight"
      content={menu}
      trigger="click"
      style={{ height: 100, overflowY: "scroll" }}
      overlayStyle={{ maxWidth: "50vw" }}
    >
      <Button shape="circle" icon={icon} size={"large"} />
    </Popover>
  );
}

export default SignOutDropDown;
